import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/scrollbar.scss';
//# sourceMappingURL=index.mjs.map
